import {
  PlateElement,
  PlateElementProps,
} from 'lib-knowledge-document-structure/plate/common';
import { useLink } from 'lib-knowledge-document-structure/plate/link';
import {
  MyLinkElement,
  MyValue,
} from 'lib-knowledge-document-structure/plateTypes';
import { forwardRef } from 'react';

import s from './elements.module.scss';

const LinkElement = forwardRef<
  React.ElementRef<typeof PlateElement>,
  PlateElementProps<MyValue, MyLinkElement>
>(({ className, children, ...props }, ref) => {
  const { props: linkProps } = useLink({ element: props.element });

  return (
    <PlateElement
      asChild
      ref={ref}
      className={className}
      {...linkProps}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {...(props as any)}
    >
      <a className={s.link}>{children}</a>
    </PlateElement>
  );
});

LinkElement.displayName = 'LinkElement';

export { LinkElement };
